/* global parameters, elementorFrontend, jQuery */

function ready(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        fn();
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

ready(function () {
    var select = document.getElementById("sort-loop-select");
    if (!select) return;

    select.addEventListener("change", function () {
        var wrapper = document.querySelector(".sort-loop-grid");
        var container = wrapper ? wrapper.querySelector(".elementor-loop-container") : null;

        if (!container) {
            console.warn("Loop grid container not found for sort-loop.js");
            return;
        }

        container.classList.add("is-loading");

        var currentCategory = window.sortLoopContext && window.sortLoopContext.categorySlug || "";

        var formData = new URLSearchParams({
            action: "SortLoopGrid",
            nonce: parameters.nonce_sort_loop,
            sort: select.value,
            paged: 1,
            tax: currentCategory
        });

        fetch(parameters.url_admin_ajax, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData
        }).then(function (res) {
            return res.json();
        }).then(function (res) {
            if (res.success) {
                container.innerHTML = res.data.html;

                if (window.elementorFrontend && window.jQuery) {
                    elementorFrontend.elementsHandler.runReadyTrigger(jQuery(wrapper));
                }
            } else {
                console.error("Sort loop error:", res);
            }
        }).catch(function (err) {
            console.error("Sort loop fetch failed:", err);
        }).finally(function () {
            container.classList.remove("is-loading");
        });
    });
});